import { render, staticRenderFns } from "./SolutionList.vue?vue&type=template&id=03bcd19e&scoped=true&"
import script from "./SolutionList.vue?vue&type=script&lang=ts&"
export * from "./SolutionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bcd19e",
  null
  
)

export default component.exports